import styles from "./index.module.scss";
import { TextInput } from "components/inputs/text-input/TextInput";
import { useTranslation } from "react-i18next";

export interface ConfirmStepProps {
    error: string | null;
    password: string;
    setPassword: (password: string) => void;
}

export const ConfirmStep = ({
    error,
    password,
    setPassword
}: ConfirmStepProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles["confirm-step-container"]}>
            <p>{t("account-delete:password-validation")}</p>
            <TextInput
                id="password"
                type="password"
                placeholder={t("profile:password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={error}
            />
        </div>
    );
};
